import React, { useEffect } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Layout from './hoc/Layout';
import Home from './containers/Pages/Home';
import Login from './containers/Pages/Login';
import Logout from './containers/Pages/Logout';
import Logs from './containers/Pages/Logs';
import OrderHistory from './containers/Pages/OrderHistory';
import OrderView from './containers/Pages/OrderView';
import Settlement from './containers/Pages/Settlements';
import SettlementView from './containers/Pages/SettlementView';
import ChangePassword from './containers/Pages/ChangePassword';
import SecurityQuestions from './containers/Pages/SecurityQuestions';
import FrequentlyAskedQuestions from './containers/Pages/FrequentlyAskedQuestions';

import requireAuthentication from './hoc/requireAuthentication';

import * as actions from './store/actions/index';
import Paylocity from './containers/Pages/Paylocity';

const app = props => {
  const { onTryAutoSignin } = props;

  useEffect(() => {
    onTryAutoSignin();
  }, []);

  return (
    <Layout>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <Route path="/logs" component={requireAuthentication(Logs)} />
        <Route path="/loads/:id" component={requireAuthentication(OrderView)} />
        <Route path="/loads" component={requireAuthentication(OrderHistory)} />
        <Route path="/settlement/:id" component={requireAuthentication(SettlementView)} />
        <Route path="/settlement" component={requireAuthentication(Settlement)} />
        <Route path="/change-password" component={requireAuthentication(ChangePassword)} />
        <Route path="/security-questions" component={requireAuthentication(SecurityQuestions)} />
        <Route path='/paylocity' component={requireAuthentication(Paylocity)} />
        <Route path='/faq' component={requireAuthentication(FrequentlyAskedQuestions)} />
        <Route exact path="/" component={requireAuthentication(Home)} />
        <Redirect to="/" />
      </Switch>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignin: () => dispatch(actions.authCheckState())
  };
}

export default withRouter(connect(null, mapDispatchToProps)(app));